import React from 'react';
import styled from 'styled-components';
import { mq } from '../../../../../../../common/src/utils/styledComponentsUtils';

interface Props {
  isSelected: boolean;
  onClick?: () => void;
  isDisabled?: boolean;
}

const RadioButton: React.FC<React.PropsWithChildren<Props>> = ({
  isSelected,
  children,
  isDisabled,
  onClick = () => null,
  ...otherProps
}) => {
  if (children)
    return (
      <Wrapper
        onClick={() => !isDisabled && onClick()}
        isDisabled={isDisabled}
        {...otherProps}
      >
        <SmallRadioButtonComponent
          isSelected={isSelected}
          data-test-id="ProdFac_RadioInputComponent_RadioButton"
          isDisabled={isDisabled}
        />
        <Label>{children}</Label>
      </Wrapper>
    );

  return (
    <RadioButtonComponent
      isSelected={isSelected}
      onClick={() => !isDisabled && onClick()}
      isDisabled={isDisabled}
      data-test-id={`ProdFac_RadioInputComponent_RadioButton_${
        isSelected ? 'CHECKED' : 'UNCHECKED'
      }`}
      {...otherProps}
    />
  );
};

const RadioButtonComponent = styled.div<{
  isSelected: boolean;
  isDisabled?: boolean;
}>`
  background: ${({ isDisabled }) => (isDisabled ? '#f7f7f7' : 'white')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  min-width: 3rem;
  height: 3rem;
  padding: 4px;

  border: ${({ isSelected, theme, isDisabled }) =>
    isSelected
      ? `2px solid ${
          isDisabled ? 'rgba(118, 118, 118, 0.3)' : theme.primary[500]
        }`
      : `2px solid ${
          isDisabled ? 'rgba(118, 118, 118, 0.3)' : theme.gray[100]
        }`};
  border-radius: 9999px;

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 9999px;
    background-color: ${({ isSelected, theme, isDisabled }) =>
      isSelected
        ? isDisabled
          ? 'rgba(118, 118, 118, 0.3)'
          : theme.primary[500]
        : isDisabled
        ? '#f7f7f7'
        : 'white'};
  }
`;

const SmallRadioButtonComponent = styled(RadioButtonComponent)`
  min-width: 3rem;
  height: 3rem;
  margin-right: 1.6rem;
  padding: 3px;

  ${mq.laptop} {
    min-width: 2rem;
    height: 2rem;
    margin-right: 0.8rem;
  }
`;

const Label = styled.p`
  font-size: 1.6rem;
  line-height: 120%;

  ${mq.laptop} {
    font-size: 1.4rem;
  }
`;

const Wrapper = styled.div<{
  isDisabled?: boolean;
}>`
  display: flex;
  align-items: center;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.4' : '1')};
`;

export default RadioButton;
